import React from 'react';
import { CircularLoading, SIZE_MEDIUM } from '@mds/mds-reactjs-library';
import * as S from './Loader.styles';

/**
 * Full-page or inline loader matching msa-frontend-eco pattern.
 * @param {string} [title] - Optional text below the spinner (default: "Loading")
 * @param {string} [size] - MDS CircularLoading size: "xsm" | "sm" | "md" | "lg" | "xl"
 * @param {string} [height] - Container height (default: "43vh")
 */
export const Loader = ({ title, size, height }) => (
  <S.LoaderContainer height={height}>
    <CircularLoading indeterminate size={size || SIZE_MEDIUM} />
    <S.TitleContainer>{title != null ? title : 'Loading'}</S.TitleContainer>
  </S.LoaderContainer>
);

export default Loader;
